








import { Component, Vue, Ref, Prop, Watch } from "vue-property-decorator";
import { gmapApi } from "vue2-google-maps";

@Component
export default class Gmap extends Vue {
    @Prop() markers: any;

    @Prop({ default: 10 }) zoom?: number;

    @Ref() readonly map!: any;

    mapOptions = {
        mapId: "faa53e550840b271",
        zoomControl: false,
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false,
        disableDefaultUi: true
    };

    mounted() {
        this.map.$mapPromise.then((map: any) => {
            if (this.markers.length === 1) {
                map.panTo(this.markers[0]);
            } else {
                this.$nextTick(() => {
                  // @ts-ignore
                    const bounds = new google.maps.LatLngBounds();
                    for (let m of this.markers) {
                        bounds.extend(m);
                    }
                    this.map.fitBounds(bounds);
                });
            }
        });
    }

    get google() {
        return gmapApi;
    }
}
